module.exports = __webpack_public_path__ + "img/cours-lac-suisse.c5faf1ce.jpg";